import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { SettingService } from 'src/app/applicationModules/settings/services/settingService/setting.service';
import { DataSharingService } from 'src/app/middleware/common/resuableServices/data-sharing.service';
import { ReusableClasses } from 'src/app/middleware/common/reusableclassesAndFunctions/reusable-classes';
import { StatusConstant } from 'src/app/middleware/common/status/status-constant';
import { EncryptionService } from 'src/app/middleware/encryption/encryption.service';
import { LoaderService } from 'src/app/middleware/shared/loader/loader.service';
import * as jwt_decode from 'jwt-decode';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { MatRadioChange } from '@angular/material/radio';
//import { ModuleName } from '../../services/task.enum';

export interface State {
  name: string;
  email: string;
  role: string;
  pic: string;
}

@Component({
  selector: 'app-task-assign',
  templateUrl: './task-assign.component.html',
  styleUrls: ['./task-assign.component.scss']
})
export class TaskAssignComponent implements OnInit {

  @Output() closeAssignedTask = new EventEmitter<boolean>();
  @Input() taskId : number;
  @Input() fromList : boolean = false;
  
  organizationId: string;
  databaseId: string;
  currentUser: any;
  responseHolder: any;  
  OfficeIDList: any = [];
  myOfficeID: any;

  contactsList: any=[];
  timeout = null;  
  stateCtrlSubject = new FormControl();
  filteredStates1: Observable<any[]>;
  stateCtrl = new FormControl();
  filteredStates: Observable<State[]>;
  //roleInputCurrentvalue:any;
  stateCtrSendlValue: any;
  stateCtrlValue:string;
  objectList:any=[];
  contactemail:any;
  anonymousEmail:any=[]=[];
  addEmailButtonShow:boolean=false;
  selectedContacts :any=[]=[];
 
  ShowContactBox:boolean=false;
  ShowRoleBox:boolean=false;
  ShowEmailBox:boolean=false;
  ShowUserBox:boolean=false;
  ContactName:string="";
  spinner:boolean=false;

  showTaskUpdateButton:boolean=false;

  getTaskAssignedEntityInDetails:any=[]=[];
  checkedContact:boolean=false;
  checkedRole:boolean=false;
  checkedEmail:boolean=false;
  checkedUser:boolean=false;
  
  entityTypeAssignee:number=1;
  taskAssignedEntity:any=[]=[];
 
  taskDetailList:any=[]=[];

  menuModulesList:any=[]=[];
  
  ContactShowName:string="";
  
  constructor(private loaderService: LoaderService,private cdr: ChangeDetectorRef,private _dataSharingService: DataSharingService,
    private router: Router,private reusableClass: ReusableClasses,private encryptionAlgo: EncryptionService,  
    private statusConst: StatusConstant,private settingsService: SettingService,private toastr: ToastrService) {
    const encryptedtoken = sessionStorage.getItem('userToken');
    this.databaseId = sessionStorage.getItem('databaseId')?? '';
     this.organizationId = sessionStorage.getItem('organizationID')?? '';
    const token = this.encryptionAlgo.get(this.reusableClass.encryptionKey, encryptedtoken);
    this.currentUser = jwt_decode(token);

    var offices = JSON.parse(sessionStorage.getItem('officeList'));
    offices.forEach(oe => {
      this.OfficeIDList.push(oe.officeID);
      if (oe.isMyoffice == true)
        this.myOfficeID = oe.officeID;
    });

    this.stateCtrl.setValue(this.stateCtrlValue);
    this.filteredStates = this.stateCtrl.valueChanges.pipe(
      startWith(''),map((state) => (state ? this._filterStates(state) : this.states.slice()))
    );
  }

  ngOnInit(): void {  
  }

  ngOnChanges(changes: SimpleChanges) {
    this.menuModulesList = JSON.parse(sessionStorage.getItem("menuModules"));    
    var SelectedContact=[];   

    SelectedContact = this.menuModulesList.filter((x:any) => x.mainModuleName == 'Contact');
      if(SelectedContact.length>0){
        this.ContactShowName = SelectedContact[0].orgModuleName;
     }
  
    this.taskId; 
    if(this.taskId>0){   
     this.getTaskDetailByID();
    }    
  }  


  getTaskDetailByID() {
    this.showTaskUpdateButton=false;
    this.loaderService.show();
    var ReqModel={
       taskID:this.taskId,
       userID: this.currentUser.UID,
       officeID: this.myOfficeID,
       organizationID: Number(this.organizationId),
       officeIDList: this.OfficeIDList
    }      
    this.settingsService.getTaskDetailByID(ReqModel).subscribe(response => {
      if (response != undefined) {
        this.responseHolder = response;        
        if (this.responseHolder.status == this.statusConst.statusSuccess && this.responseHolder.data!=null) {
          this.taskDetailList = response.data;
          
          this.entityTypeAssignee = this.taskDetailList.entityTypeAssignee;

          // Check for Assigned To
          this.getTaskAssignedEntityInDetails = this.taskDetailList.taskAssignedEntity;
          if(this.getTaskAssignedEntityInDetails.length>0){

            // Contact-1,Role-2,Email-3,User-4

            // Added For Contact
            if(this.entityTypeAssignee==1){ 
              this.checkedContact=true;
              this.checkedRole=false;
              this.checkedEmail=false;
              this.checkedUser=false;

              this.ShowContactBox=true;
              this.ShowRoleBox=false;
              this.ShowEmailBox=false;
              this.ShowUserBox=false;

             for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i){
              var shortName="";
              shortName = this.getTaskAssignedEntityInDetails[i].assigneeName.match(/\b(\w)/g).join('');
              var ReqModelContact={
                contactID: this.getTaskAssignedEntityInDetails[i].contactID,
                email: this.getTaskAssignedEntityInDetails[i].assigneeEmail,
                name: this.getTaskAssignedEntityInDetails[i].assigneeName,
                img: this.getTaskAssignedEntityInDetails[i].imageUrl,
                shortName: shortName,
               }
               this.selectedContacts.push(ReqModelContact);   
              }
            }

            // Added For Role
            if(this.entityTypeAssignee==2){ 
              this.checkedContact=false;
              this.checkedRole=true;
              this.checkedEmail=false;
              this.checkedUser=false;

              this.ShowContactBox=false;
              this.ShowRoleBox=true;
              this.ShowEmailBox=false;
              this.ShowUserBox=false;

             for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i){             
              var ReqModelRole={
                name : this.getTaskAssignedEntityInDetails[i].assigneeName,               
                roleID: this.getTaskAssignedEntityInDetails[i].roleID                   
               }
               this.selectedRole.push(ReqModelRole);   
              }
            }

             // Added For Email
            if(this.entityTypeAssignee==3){ 
              this.checkedContact=false;
              this.checkedRole=false;
              this.checkedEmail=true;
              this.checkedUser=false;

              this.ShowContactBox=false;
              this.ShowRoleBox=false;
              this.ShowEmailBox=true;
              this.ShowUserBox=false;

             for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i){             
              var ReqModelEmail={
                email : this.getTaskAssignedEntityInDetails[i].email        
               }
               this.selectedEmail.push(ReqModelEmail);   
              }
            }

              // Added For User
              if(this.entityTypeAssignee==4){ 
                this.checkedContact=false;
                this.checkedRole=false;
                this.checkedEmail=false;
                this.checkedUser=true;
  
                this.ShowContactBox=false;
                this.ShowRoleBox=false;
                this.ShowEmailBox=false;
                this.ShowUserBox=true;
  
               for (var i = 0, len = this.getTaskAssignedEntityInDetails.length; i < len; ++i){             
                var ReqModelUser={
                  name:  this.getTaskAssignedEntityInDetails[i].assigneeName,
                  email: this.getTaskAssignedEntityInDetails[i].assigneeEmail,
                  img: "",
                  userID:  this.getTaskAssignedEntityInDetails[i].userID,                       
                 }
                 this.selectedUser.push(ReqModelUser);   
                }
              }
          }else{
            // For Checked MatOption
            this.checkedContact=true;
            this.checkedRole=false;
            this.checkedEmail=false;
            this.checkedUser=false;

            this.ShowContactBox=true;
            this.ShowRoleBox=false;
            this.ShowEmailBox=false;
            this.ShowUserBox=false;

            this.entityTypeAssignee=1;
          }

          this.loaderService.hide();
        }
        else {
          this.taskDetailList=[];
          this.loaderService.hide();
        }
      }
      else {
        this.taskDetailList=[];
        this.loaderService.hide();
      }
    });
  }



  async updateTaskDetail(){

    //=====Check select Assigned To ===//
    // Contact-1,Role-2,Email-3,User-4
    this.taskAssignedEntity=[];

    // For Contact
    if(this.entityTypeAssignee==1){
     if(this.selectedContacts.length>0){
      for (var i = 0, len = this.selectedContacts.length; i < len; ++i){
        var contactTaskAssigned={
          taskAssignedEntityID: 0,
          taskID: this.taskId,
          email: "",
          contactID: this.selectedContacts[i].contactID,
          role: 0,
          userID: null,         
        }
        this.taskAssignedEntity.push(contactTaskAssigned);
      }
     }
    }

    // For Role
    if(this.entityTypeAssignee==2){
      if(this.selectedRole.length>0){
        for (var i = 0, len = this.selectedRole.length; i < len; ++i){
          var roleTaskAssigned={
            taskAssignedEntityID: 0,
            taskID: this.taskId,
            email: "",
            contactID: 0,
            roleID: this.selectedRole[i].roleID,
            userID: null,    
          }
          this.taskAssignedEntity.push(roleTaskAssigned);
        }
       }
    }

    // For Email
    if(this.entityTypeAssignee==3){
      if(this.selectedEmail.length>0){
        for (var i = 0, len = this.selectedEmail.length; i < len; ++i){
          var emailTaskAssigned={
            taskAssignedEntityID: 0,
            taskID: this.taskId,
            email: this.selectedEmail[i].email,
            contactID: 0,
            role: 0,
            userID: null,
          }
          this.taskAssignedEntity.push(emailTaskAssigned);
        }
       }
    }

    // For User
    if(this.entityTypeAssignee==4){
      if(this.selectedUser.length>0){
        for (var i = 0, len = this.selectedUser.length; i < len; ++i){
          var userTaskAssigned={
            taskAssignedEntityID: 0,
            taskID: this.taskId,
            email: "",
            contactID: 0,
            role: 0,
            userID: this.selectedUser[i].userID           
          }
          this.taskAssignedEntity.push(userTaskAssigned);
        }
       }
    }
    
    var ReqModel={
      isAddOnlyAssinee: true,
      isAttacheOnly: false,
      taskID: Number(this.taskId),
     
          //entityTypeAttached: this.entityTypeAttached,
      entityTypeAssignee: this.entityTypeAssignee,

      taskAssignedEntity: this.taskAssignedEntity,

      organizationID: Number(this.organizationId),
      databaseID: Number(this.databaseId),
      createdBy: this.currentUser.UID,
      officeID: this.myOfficeID,
      officeIDList: this.OfficeIDList    
    }
   // return;
    this.loaderService.show();
    this.spinner=true;
    this.showTaskUpdateButton=false;  
    const result = await this.settingsService.updateTaskDetails(ReqModel).toPromise();
    if (result.status === this.statusConst.statusSuccess) {
      this.spinner=false;
      this.closeAssignedTask.emit(false);
      this.loaderService.hide();
      if(this.taskId==0){
        this.toastr.success("Assign added successfully.", '', {
          timeOut: 3000,
        });
      }
      if(this.taskId>0){
        this.toastr.success("Assign update successfully.", '', {
          timeOut: 3000,
        });
      }
    }
    else {
      this.spinner=false;
      this.loaderService.hide();
      this.closeAssignedTask.emit(false);    
    } 
  }
  

  close(){
    this.addEmailButtonShow=false;
    this.showTaskUpdateButton=false;

    // For Contact
    this.selectedContacts=[];   
    this.stateCtrl.reset();
    this.contactsList=[];
  
    // For Role
    this.selectedRole=[];
    this.RoleList=[];
  
     //For Email
    this.emailAssigned="";
    this.selectedEmail=[];
  
     // For User
    this.selectedUser=[];      
    this.userList=[];
  
     // clear taskAssigned
    this.taskAssignedEntity=[];   
   
    this.closeAssignedTask.emit(false);
  }




  /// ============================================  Assigned To  ==========================================//



 // ============ For Search/Select Contact ==================//

 states= this.objectList;

 private _filterStates(value: string): State[] {
   const filterValue = value.toLowerCase();
   return this.states.filter((state) => state.name.toLowerCase().indexOf(filterValue) === 0);
 }

 selectCRE($event: MatRadioChange) {
 
  this.addEmailButtonShow=false;
  this.showTaskUpdateButton =false;
 
  // For Contact
 // this.selectedContacts=[];   
  this.stateCtrl.reset();
  this.contactsList=[];

  // For Role
 // this.selectedRole=[];
  this.RoleList=[];

   //For Email
   this.emailAssigned="";
 //  this.selectedEmail=[];

   // For User
 //  this.selectedUser=[];      
   this.userList=[];

   // clear taskAssigned
   this.taskAssignedEntity=[];

  if ($event.value === 'Contact') {
    this.ShowContactBox=true;  
    this.ShowRoleBox=false; 
    this.ShowEmailBox=false;
    this.ShowUserBox=false;

    this.entityTypeAssignee=1;   
  }
  if ($event.value === 'Role') {
    this.ShowContactBox=false;  
    this.ShowRoleBox=true; 
    this.ShowEmailBox=false;
    this.ShowUserBox=false;      
    
    this.entityTypeAssignee=2;
  }
  if ($event.value === 'Email') {
    this.ShowContactBox=false;  
    this.ShowRoleBox=false; 
    this.ShowEmailBox=true;
    this.ShowUserBox=false;

    this.entityTypeAssignee=3;
  }
  if ($event.value === 'User') {
    this.ShowContactBox=false;  
    this.ShowRoleBox=false; 
    this.ShowEmailBox=false;
    this.ShowUserBox=true; 

    this.entityTypeAssignee=4;
  }
 }

 searchContact(val) {
  if(val.length>=2){
   this.contactsList=[];
     if(val != ''){
     clearTimeout(this.timeout)
     this.timeout = setTimeout(() => {      
      this.getContactListCoreImplementation(val)
     }, 500);
   }else{
     this.contactsList=[];
   }
 }
}

 getContactListCoreImplementation(searchValue: any) {
   var ReqModel = {
     DatabaseID: Number(this.databaseId),
     OrganizationID: Number(this.organizationId),
     UserID: this.currentUser.UID,
     searchValue: searchValue,
     PageSize: 0,      
   }
   this.settingsService.GetContactListCoreImplementation(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.contactsList = response.data.contactListModel;
         this.contactsList.forEach(e => {
           e.shortName = e.name.match(/\b(\w)/g).join('');
         });    
       }else{
         this.contactsList=[];
       }
      }
    })
 }


 addcontact(){
   var findContact = this.selectedContacts.filter((x) => x.email === this.contactemail);
   if(findContact.length!=undefined && findContact.length>0){
    let user = this.selectedContacts.find(m=>m.email == findContact[0].email); 
    if(user = undefined || user=='' || user == null){
      var req={
        contactID: findContact[0].contactID,
        email: findContact[0].email,
        name: "",
        img:"",        
        shortName: ""
       }
       this.selectedContacts.unshift(req); 
       this.stateCtrl.reset();
       this.showTaskUpdateButton=false;
       if (this.selectedContacts.length > 0) {
        this.showTaskUpdateButton = true;
      }
      else {
        this.showTaskUpdateButton = false;
      }
     } else{
        this.showTaskUpdateButton=false;
        this.stateCtrl.reset();
        if (this.selectedContacts.length > 0) {
          this.showTaskUpdateButton = true;
        }
        else {         
          this.showTaskUpdateButton = false;
        }
     }    
   }    
 }

 onEnter(event,contact) {
   this.stateCtrl.setValue(''); 
   var findContact = this.selectedContacts.filter((x) => x.name === event.target.value);
   if(findContact.length!=undefined && findContact.length>0){
    let user = this.selectedContacts.find(m=>m.contactID == findContact[0].contactID); 
    if(user == undefined || user=='' || user == null){
      var req={
        contactID: findContact[0].contactID,
        email: findContact[0].email,
        name: findContact[0].name,
        img:findContact[0].imageUrl,        
        shortName: findContact[0].shortName
       }
       this.selectedContacts.unshift(req); 
       this.stateCtrl.reset();
       if (this.selectedContacts.length > 0) {
        this.showTaskUpdateButton = true;
      }
      else {
        this.showTaskUpdateButton = false;
      }
     } else{
        this.stateCtrl.reset();
        if (this.selectedContacts.length > 0) {
          this.showTaskUpdateButton = true;
        }
        else {
          this.showTaskUpdateButton = false;
        }
     }    
   }        
 }

 contactSelected(contactSelected: any) {
     this.stateCtrl.setValue('');
     let user= this.selectedContacts.find(m=>m.contactID == contactSelected.contactID); 
     if(user == undefined || user=='' || user == null){
       if(contactSelected.contactID == 0) {          
         return;
        }
        var ReqModel={
         contactID: contactSelected.contactID,
         email: contactSelected.email,
         name: contactSelected.name,
         img: contactSelected.imageUrl,
         shortName: contactSelected.shortName,
        }
        this.selectedContacts.unshift( ReqModel);        
        this.stateCtrl.reset();
        if (this.selectedContacts.length > 0) {
         this.showTaskUpdateButton = true;
        }else {
         this.showTaskUpdateButton = false;
       }
     }      
 }
   
 removeContact(item:any) {
    const index = this.selectedContacts.indexOf(item);
    if (index >= 0) {
     this.selectedContacts.splice(index, 1);
     }
    if(this.selectedContacts.length == 0){
     this.stateCtrl.reset();
     this.showTaskUpdateButton =false;
    }     
 }

  

  // =========================== For Role  ===============================//

  RoleList:any=[]=[];
  selectedRole:any=[]=[];
  
 searchRoles(searchValue:any){
   var ReqModel={
     searchKey: "",
     pageIndex: 0,
     pageSize: 0,
     databaseID:  Number(this.databaseId),
     organizationID: Number(this.organizationId),
     searchValue: searchValue
   }
   this.settingsService.getSharedAccessRoles(ReqModel).subscribe(response => {
     if (response != undefined) {
       this.responseHolder = response;
       if (this.responseHolder.status == this.statusConst.statusSuccess) {
         this.RoleList = response.data;       
       }
       else{
       }
     }
   });
 }

 roleSelected(roleSelected:any){
   this.stateCtrl.setValue('');
   let role= this.selectedRole.find(m=>m.roleID == roleSelected.roleID);  
   if(roleSelected.roleID == 0) {     
    let newRole = this.selectedRole.find(m=>m.name.toLowerCase() == roleSelected.name.toLowerCase());
    if(newRole == undefined) { 
      this.selectedRole.push({       
         name : roleSelected.roleName,               
         roleID: roleSelected.roleID              
       });
       if(this.selectedRole.length > 0){
         this.showTaskUpdateButton=true;
       }
       if(this.selectedRole.length == 0){
         this.showTaskUpdateButton=false;
       }
     }
     return;
   }
   
   if(role == undefined || role == '' || role == null) { 
     this.selectedRole.push({
       name : roleSelected.roleName,     
       roleID:roleSelected.roleID         
    });
   } 
 
   if(this.selectedRole.length > 0){
     this.showTaskUpdateButton=true;
   }
   if(this.selectedRole.length == 0){
     this.showTaskUpdateButton=false;
   }
 }

 removeRole(item:any){
   const index = this.selectedRole.indexOf(item);
   if (index >= 0) {
      this.selectedRole.splice(index, 1);
    }      
   if(this.selectedRole.length > 0){
      this.showTaskUpdateButton =true;
    }
   if(this.selectedRole.length == 0){
      this.showTaskUpdateButton =false;
   }
 }



  // ======================= Email ===============================//

  selectedEmail:any=[]=[];
  emailAssigned:string = null;

  emailCheck(searchValue:any){
   if(searchValue.toLowerCase() == searchValue.toLowerCase().match('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')){
     this.emailAssigned=searchValue;
     this.addEmailButtonShow =true;
   }else{
     this.addEmailButtonShow =false;
   }
  }

  addEmail(){
   var obj={
     email:this.emailAssigned
   }

   var check=[];

   check = this.selectedEmail.filter(x=> x.email.toLowerCase()==this.emailAssigned.toLowerCase())
   if(check.length==0){
     this.selectedEmail.push(obj);
     this.emailAssigned="";
     this.addEmailButtonShow=false;
   }else{
     this.emailAssigned="";
     this.addEmailButtonShow=false;
     this.toastr.warning('Email allready added.', '', {
       timeOut: 3000,
     });
   } 

   if(this.selectedEmail.length > 0){
    this.showTaskUpdateButton=true;
  }
  if(this.selectedEmail.length == 0){
    this.showTaskUpdateButton=false;
  }
  }

  removeEmail(item:any) {
   const index = this.selectedEmail.indexOf(item);
   if (index >= 0) {
    this.selectedEmail.splice(index, 1);
    }
    if(this.selectedEmail.length > 0){
      this.showTaskUpdateButton =true;
    }
   if(this.selectedEmail.length == 0){
      this.showTaskUpdateButton =false;
   }    
  }





// ======================= User ===============================//

selectedUser:any=[]=[];
userList: any=[];

searchUser(val) {
if(val.length>=2){
 this.userList=[];
   if(val != ''){
   clearTimeout(this.timeout)
   this.timeout = setTimeout(() => {      
    this.getUserListCoreImplementation(val)
   }, 500);
 }else{
   this.userList=[];
 }
}
}

getUserListCoreImplementation(searchValue: any) {
 if (searchValue == "" || searchValue == null || searchValue == undefined) {
   this.userList = [];
   return;
 }
 var ReqModel = {
   DatabaseID: Number(this.databaseId),
   OrganizationID: Number(this.organizationId),
   searchKey: searchValue.trim(),
   PageSize: 0,
   pageIndex: 0,
   UserID: this.currentUser.UID
 }
 this.settingsService.GetUserList(ReqModel).subscribe(response => {
   if (response != undefined) {
     this.responseHolder = response;
     if (this.responseHolder.status == this.statusConst.statusSuccess) {
       this.userList = response.data.userModel;
       this.userList.map((res) => {
         if (res.email != null) {
           res.email = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.email);
         }
         if (res.firstName != null) {
           res.firstName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.firstName);
         }
         if (res.lastName != null) {
           res.lastName = this.encryptionAlgo.get(this.reusableClass.decryptionKey, res.lastName);
         }
         return res;
       });
       this.userList = this.userList;          
     }
   }
 });
}

userSelected(userSelected: any) {
 let user = this.selectedUser.find(m => m.userID == userSelected.uuid);
 if (user == undefined || user == '' || user == null) {
   this.selectedUser.push({
     name: userSelected.firstName + " " + userSelected.lastName,
     email: userSelected.email,
     img: "",
     userID: userSelected.uuid,
   });
   if (this.selectedUser.length > 0) {
     this.showTaskUpdateButton = true;
   }
   else {
     this.showTaskUpdateButton = false;
   }
 }
}
 
removeUser(item:any) {
  const index = this.selectedUser.indexOf(item);
  if (index >= 0) {
   this.selectedUser.splice(index, 1);
   }
  if(this.selectedUser.length == 0){
   this.stateCtrl.reset();
   this.showTaskUpdateButton =false;
  }     
}




}
